import React from 'react'
import slideImg from '../assets/slider-images/payment.gif'

function PaymentSlides() {
    return (
        <div className="py-4">
            <img className="img-fluid" src={slideImg} alt="" />
        </div>
    )
}

export default PaymentSlides